import { j as c } from "./jsx-runtime-e6RZPHeG.js";
import { memo as o } from "react";
const v = ({
  title: h,
  titleId: e,
  ...l
}) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": e,
    ...l,
    children: [
      h ? /* @__PURE__ */ c.jsx("title", { id: e, children: h }) : null,
      /* @__PURE__ */ c.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M875.661 285.222c0-47.147-38.187-85.333-85.333-85.333h-12.373v-37.333a19.12 19.12 0 0 0-19.2-19.2h-57.6c-10.453 0-19.2 8.533-19.2 19.2v37.333h-339.2v-37.333a19.12 19.12 0 0 0-19.2-19.2h-57.6a19.12 19.12 0 0 0-19.2 19.2v37.333h-11.093c-47.147 0-85.333 38.187-85.333 85.333v52.053h725.333zM769.069 590.669c0 11.776-9.557 21.333-21.333 21.333h-64c-11.776 0-21.333-9.557-21.333-21.333v-64c0-11.776 9.557-21.333 21.333-21.333h64c11.776 0 21.333 9.557 21.333 21.333zm0 176c0 11.776-9.557 21.333-21.333 21.333h-64c-11.776 0-21.333-9.557-21.333-21.333v-64c0-11.776 9.557-21.333 21.333-21.333h64c11.776 0 21.333 9.557 21.333 21.333zm-202.006-176c0 11.776-9.557 21.333-21.333 21.333h-64c-11.776 0-21.333-9.557-21.333-21.333v-64c0-11.776 9.557-21.333 21.333-21.333h64c11.776 0 21.333 9.557 21.333 21.333zm0 176c0 11.776-9.557 21.333-21.333 21.333h-64c-11.776 0-21.333-9.557-21.333-21.333v-64c0-11.776 9.557-21.333 21.333-21.333h64c11.776 0 21.333 9.557 21.333 21.333zm-201.984-176c0 11.776-9.557 21.333-21.333 21.333h-64c-11.797 0-21.333-9.557-21.333-21.333v-64c0-11.776 9.536-21.333 21.333-21.333h64c11.776 0 21.333 9.557 21.333 21.333zm0 176c0 11.776-9.557 21.333-21.333 21.333h-64c-11.797 0-21.333-9.557-21.333-21.333v-64c0-11.776 9.536-21.333 21.333-21.333h64c11.776 0 21.333 9.557 21.333 21.333zM150.402 399.991v389.845c0 57.899 38.208 104.832 85.333 104.832h554.667c47.125 0 85.333-46.933 85.333-104.832V399.991z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), i = o(v);
export {
  i as default
};
